<template>
  <div>
    <el-dialog
      :title="game ? '编辑赛事' : '新增赛事'"
      :visible.sync="dialogVisible"
      width="35%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="false"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      :show-close="false"
      custom-class="game-dialog-centered">
      
      <!-- 添加自定义的关闭按钮，替代对话框默认的右上角X按钮 -->
      <div style="position: absolute; top: 20px; right: 20px; cursor: pointer; z-index: 2000;" @click="handleCloseButtonClick">
        <i class="el-icon-close" style="font-size: 20px;"></i>
      </div>
      
      <!-- 确认关闭的内部对话框 -->
      <div v-if="showConfirmation" class="confirmation-overlay">
        <div class="confirmation-dialog">
          <div class="confirmation-content">
            <i class="el-icon-warning" style="color: #E6A23C; font-size: 24px; margin-right: 10px;"></i>
            <span>有未保存的修改，确认要关闭吗？</span>
          </div>
          <div class="confirmation-buttons">
            <el-button size="small" @click="cancelClose">取 消</el-button>
            <el-button size="small" type="primary" @click="confirmClose">确 定</el-button>
          </div>
        </div>
      </div>
      
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="用户名" prop="username">
          <!-- 管理员：可选择其他用户；普通用户：只读 -->
          <template v-if="isAdmin">
            <el-select
              v-model="form.username"
              placeholder="请选择用户"
              filterable
              clearable
              :loading="userOptionsLoading"
              @visible-change="onUserSelectVisible"
              style="width: 100%"
            >
              <el-option
                v-for="u in userOptions"
                :key="u.username"
                :label="`${u.name || u.username} (${u.username})`"
                :value="u.username"
              />
            </el-select>
          </template>
          <template v-else>
            <el-input
              v-model="form.username"
              placeholder="用户名"
              :disabled="true"
              :readonly="true">
            </el-input>
          </template>
        </el-form-item>
        
        <el-form-item label="赛事名称" prop="game_name">
          <el-input v-model="form.game_name"></el-input>
        </el-form-item>
        
        <el-form-item label="赛事类型" prop="game_type">
          <el-select v-model="form.game_type" placeholder="请选择赛事类型">
            <el-option
              v-for="item in dictData.game_type"
              :key="item.dict_value"
              :label="item.dict_label || item.dict_value"
              :value="item.dict_value">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="赛事级别" prop="game_level">
          <el-select v-model="form.game_level" placeholder="请选择赛事级别">
            <el-option
              v-for="item in dictData.game_level"
              :key="item.dict_value"
              :label="item.dict_label || item.dict_value"
              :value="item.dict_value">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="赛事规模" prop="game_scale">
          <el-select v-model="form.game_scale" placeholder="请选择赛事规模">
            <el-option
              v-for="item in dictData.game_scale"
              :key="item.dict_value"
              :label="item.dict_label || item.dict_value"
              :value="item.dict_value">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="赛事机构" prop="game_org">
          <el-select v-model="form.game_org" placeholder="请选择赛事机构">
            <el-option
              v-for="item in dictData.game_org"
              :key="item.dict_value"
              :label="item.dict_label || item.dict_value"
              :value="item.dict_value">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="赛事URL" prop="game_url">
          <el-input v-model="form.game_url"></el-input>
        </el-form-item>
        
        <el-form-item label="赛事时间" prop="game_time">
          <el-date-picker
            v-model="form.game_time"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        
        <el-form-item label="参赛人数" prop="parameter_number">
          <el-input-number 
            v-model="form.parameter_number" 
            :min="0"
            :controls-position="'right'"
            :precision="0"
            :step="1"
            placeholder="请输入参赛人数">
          </el-input-number>
        </el-form-item>
        
        <el-form-item label="名次" prop="rank">
          <el-input-number 
            v-model="form.rank" 
            :min="0"
            :max="form.parameter_number || undefined"
            :controls-position="'right'"
            :precision="0"
            :step="1"
            placeholder="请输入名次">
          </el-input-number>
        </el-form-item>
        
        <el-form-item label="备注" prop="note">
          <el-input type="textarea" v-model="form.note"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseButtonClick">取 消</el-button>
        <el-button 
          type="primary" 
          @click="handleSubmit" 
          :loading="loading" 
          :disabled="game && !hasFormChanges">
          确 定
        </el-button>
        <el-button 
          v-if="!game"
          type="success" 
          @click="handleSubmitAndAddQuestions" 
          :loading="loading">
          确定并添加题目
        </el-button>
      </div>
    </el-dialog>

    <batch-question-dialog
      ref="batchQuestionDialog"
      :visible.sync="batchQuestionDialogVisible"
      :game-code="form.game_code"
      @success="handleQuestionSuccess"
      @close="batchQuestionDialogVisible = false"
    />
  </div>
</template>

<script>
import axios from 'axios'
import BatchQuestionDialog from './BatchQuestionDialog.vue'
import { getDictData, getBatchDictData } from '@/api/dict'
import { addGame, updateGame } from '@/api/game'

export default {
  name: 'GameDialog',
  components: {
    BatchQuestionDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    game: {
      type: Object,
      default: null
    }
  },
  data() {
    const validateUrl = (rule, value, callback) => {
      if (!value) {
        callback()
      } else if (!/^https?:\/\//.test(value)) {
        callback(new Error('请输入正确的URL格式'))
      } else {
        callback()
      }
    }
    
    const validateParameterNumber = (rule, value, callback) => {
      if (value === null || value === '') {
        callback(new Error('请输入参赛人数'))
      } else if (value < 0) {
        callback(new Error('参赛人数不能小于0'))
      } else {
        callback()
      }
    }
    
    const validateRank = (rule, value, callback) => {
      if (value === null || value === '') {
        callback(new Error('请输入名次'))
      } else if (value < 0) {
        callback(new Error('名次不能小于0'))
      } else if (value > this.form.parameter_number) {
        callback(new Error('名次不能大于参赛人数'))
      } else {
        callback()
      }
    }

    // 从 localStorage 获取用户信息
    const userInfo = localStorage.getItem('userInfo') ? 
      JSON.parse(localStorage.getItem('userInfo')) : {}

    return {
      dialogVisible: false,
      batchQuestionDialogVisible: false,
      loading: false,
      showConfirmation: false,
      isClosePending: false,
      // 管理员判定更稳健：role 为 0/"0" 或用户名为 admin
      isAdmin: String(userInfo.role) === '0' || userInfo.username === 'admin',
      username: userInfo.name || '',
      userOptions: [],
      userOptionsLoading: false,
      form: {
        username: userInfo.username || '',
        game_name: '',
        game_type: '',
        game_level: '',
        game_scale: '',
        game_org: '',
        game_url: '',
        game_time: '',
        parameter_number: null,
        rank: null,
        note: '',
        game_code: ''
      },
      dictData: {
        game_type: [],
        game_level: [],
        game_scale: [],
        game_org: []
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        game_name: [
          { required: true, message: '请输入赛事名称', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        game_type: [
          { required: true, message: '请选择赛事类型', trigger: 'change' }
        ],
        game_level: [
          { required: true, message: '请选择赛事级别', trigger: 'change' }
        ],
        game_scale: [
          { required: true, message: '请选择赛事规模', trigger: 'change' }
        ],
        game_org: [
          { required: true, message: '请选择赛事机构', trigger: 'change' }
        ],
        game_url: [
          { validator: validateUrl, trigger: 'blur' }
        ],
        game_time: [
          { required: true, message: '请选择赛事时间', trigger: 'change' }
        ],
        parameter_number: [
          { required: true, message: '请输入参赛人数', trigger: 'change' },
          { type: 'number', message: '参赛人数必须为数字' },
          { validator: validateParameterNumber, trigger: 'change' }
        ],
        rank: [
          { required: true, message: '请输入名次', trigger: 'change' },
          { type: 'number', message: '名次必须为数字' },
          { validator: validateRank, trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    hasFormChanges() {
      if (!this.game) return true;
      return Object.keys(this.form).some(key => {
        if (key === 'game_time') {
          const formDate = this.form[key] ? this.formatDate(this.form[key]) : '';
          const gameDate = this.game[key] ? this.formatDate(new Date(this.game[key])) : '';
          return formDate !== gameDate;
        }
        if (key === 'parameter_number' || key === 'rank') {
          return Number(this.form[key]) !== Number(this.game[key]);
        }
        return this.form[key] !== this.game[key];
      });
    }
  },
  watch: {
    visible: {
      handler(val) {
        console.log('visible changed to:', val)
        if (val === false && this.dialogVisible) {
          this.handleCloseRequest()
        } else         if (val === true && !this.dialogVisible) {
          this.dialogVisible = true
          const userInfo = localStorage.getItem('userInfo') ? 
            JSON.parse(localStorage.getItem('userInfo')) : {}
          // 每次打开时重新判定是否管理员，避免缓存造成误判
          this.isAdmin = String(userInfo.role) === '0' || userInfo.username === 'admin'
          // 新增时默认当前用户；编辑时保持原值
          if (!this.game) {
            this.form.username = userInfo.username || ''
          }
          // 管理员时预取选项
          if (this.isAdmin && this.userOptions.length === 0) {
            this.fetchUserOptions()
          }
          // 确保编辑时已有用户名可以在下拉中显示
          if (this.isAdmin) {
            this.ensureCurrentUserOption()
          }
        }
      },
      immediate: true
    },
    dialogVisible(val) {
      console.log('dialogVisible changed to:', val)
      if (this.$attrs.visible !== val) {
        this.$emit('update:visible', val)
      }
      
      if (!val) {
        this.showConfirmation = false
        this.isClosePending = false
      }
    },
    game: {
      handler(newGame) {
        const userInfo = localStorage.getItem('userInfo') ? 
          JSON.parse(localStorage.getItem('userInfo')) : {}
        
        if (newGame) {
          // 编辑模式：使用原有值，不覆盖 username
          this.form = JSON.parse(JSON.stringify({
            ...newGame
          }))
          console.log('编辑对话框数据:', this.form)
          if (this.isAdmin) {
            this.ensureCurrentUserOption()
          }
        } else {
          this.form = {
            username: userInfo.username || '',
            game_name: '',
            game_type: '',
            game_level: '',
            game_scale: '',
            game_org: '',
            game_url: '',
            game_time: '',
            parameter_number: undefined,
            rank: undefined,
            note: ''
          }
        }
      },
      immediate: true
    },
    'form.parameter_number'(val) {
      if (this.form.rank !== null) {
        this.$refs.form?.validateField('rank')
      }
    },
    batchQuestionDialogVisible(val) {
      console.log('batchQuestionDialogVisible changed to:', val)
    }
  },
  created() {
    this.fetchDictData()
    if (!this.game) {
      const userInfo = localStorage.getItem('userInfo') ? 
        JSON.parse(localStorage.getItem('userInfo')) : {}
      this.form.username = userInfo.username || ''
    }
    // 预加载用户选项（仅管理员）
    if (this.isAdmin) {
      this.fetchUserOptions()
    }
  },
  methods: {
    async fetchDictData() {
      try {
        const dictKeys = ['game_type', 'game_level', 'game_scale', 'game_org']
        const results = await getBatchDictData(dictKeys)
        
        results.forEach((res, index) => {
          const key = dictKeys[index]
          if (res.code === 200 && Array.isArray(res.data)) {
            this.dictData[key] = res.data
          } else {
            console.error(`获取字典数据失败: ${key}`, res)
            this.$message.error(`获取${key}字典数据失败`)
          }
        })

        const missingKeys = dictKeys.filter(key => !this.dictData[key] || this.dictData[key].length === 0)
        if (missingKeys.length > 0) {
          this.$message.warning(`以下字典数据未能成功加载: ${missingKeys.join(', ')}`)
        }
      } catch (error) {
        console.error('获取字典数据失败:', error)
        this.$message.error('获取字典数据失败，请刷新页面重试')
      }
    },
    async fetchUserOptions() {
      try {
        this.userOptionsLoading = true
        const res = await axios.get('/api/user/options')
        if (res.data && res.data.code === 200) {
          this.userOptions = res.data.data.items || []
        }
      } catch (e) {
        console.error('获取用户选项失败:', e)
      } finally {
        this.userOptionsLoading = false
      }
    },
    onUserSelectVisible(visible) {
      if (visible && this.userOptions.length === 0) {
        this.fetchUserOptions()
      }
    },
    ensureCurrentUserOption() {
      if (!this.form || !this.form.username) return
      const exists = this.userOptions.some(u => u.username === this.form.username)
      if (!exists) {
        this.userOptions.unshift({ username: this.form.username, name: this.form.username, status: 1 })
      }
    },
    resetForm() {
      const userInfo = localStorage.getItem('userInfo') ? 
        JSON.parse(localStorage.getItem('userInfo')) : {}
      this.form = {
        username: userInfo.username || '',
        game_name: '',
        game_type: '',
        game_level: '',
        game_scale: '',
        game_org: '',
        game_url: '',
        game_time: '',
        parameter_number: null,
        rank: null,
        note: '',
        game_code: ''
      }
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    handleCloseButtonClick() {
      this.handleCloseRequest()
    },
    handleCloseRequest() {
      if (this.hasFormChanges && !this.showConfirmation) {
        this.showConfirmation = true
      } else if (!this.hasFormChanges) {
        this.closeDialog()
      }
    },
    cancelClose() {
      this.showConfirmation = false
      this.isClosePending = false
    },
    confirmClose() {
      this.showConfirmation = false
      this.closeDialog()
    },
    closeDialog() {
      this.resetForm()
      this.dialogVisible = false
      this.$emit('update:visible', false)
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        this.loading = true
        
        const formData = {
          ...this.form,
          game_time: this.form.game_time ? this.formatDate(this.form.game_time) : undefined,
          parameter_number: Number(this.form.parameter_number),
          rank: Number(this.form.rank)
        }
        
        if (this.game) {
          formData.id = this.game.id
        }
        
        const res = await (this.game ? updateGame(formData) : addGame(formData))
        
        if (res.code === 200) {
          this.$message.success(this.game ? '更新成功' : '创建成功')
          this.$emit('success')
          this.closeDialog()
        }
      } catch (error) {
        console.error('提交失败:', error)
        this.$message.error(error.message || '提交失败')
      } finally {
        this.loading = false
      }
    },
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    async handleSubmitAndAddQuestions() {
      try {
        await this.$refs.form.validate()
        this.loading = true
        
        const formData = {
          ...this.form,
          game_time: this.form.game_time ? this.formatDate(this.form.game_time) : undefined,
          parameter_number: Number(this.form.parameter_number),
          rank: Number(this.form.rank)
        }
        
        const response = await addGame(formData)
        if (response.code === 200) {
          this.$message.success('添加成功')
          this.$emit('success')
          
          this.closeDialog()
          
          this.$nextTick(() => {
            this.batchQuestionDialogVisible = true
            if (this.$refs.batchQuestionDialog) {
              this.$refs.batchQuestionDialog.setGameCode(response.data.game_code)
            }
          })
        } else {
          throw new Error(response.message || '添加失败')
        }
      } catch (error) {
        console.error('添加赛事失败:', error)
        this.$message.error(error.message || '添加赛事失败')
      } finally {
        this.loading = false
      }
    },
    handleQuestionSuccess() {
      this.batchQuestionDialogVisible = false
      this.dialogVisible = false
      this.$emit('success')
      this.resetForm()
    },
    handleDialogClose() {
      this.handleCloseRequest()
    },
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* 全局对话框样式覆盖 */
::v-deep .el-dialog {
  margin-top: 0 !important;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  position: relative;
  top: 40%;
  transform: translateY(-50%);
}

::v-deep .el-dialog__body {
  overflow-y: auto;
  flex: 1;
}

/* 自定义确认对话框样式 */
.confirmation-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 3000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirmation-dialog {
  background-color: white;
  border-radius: 4px;
  padding: 20px;
  width: 300px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.confirmation-content {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.confirmation-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>

<style lang="scss">
// 全局样式 - 限制对话框最大宽度
.el-dialog__wrapper .game-dialog-centered {
  width: 35% !important;
  max-width: 600px !important;
  margin: 0 auto !important;
}

.game-dialog-centered.el-dialog {
  width: 100% !important;
}
</style>
 